import { createFileRoute } from '@tanstack/react-router'
import ImportTransactions from 'Administration/components/import/Transactions/ImportTransactions'

import AdministrationPage from '../../-administrationPage'
import { Guard } from '../../-guard'

export const Route = createFileRoute('/administration/imports/importtransaction')({
    component: () => (
        <Guard claims={['opus_royalty']}>
            <AdministrationPage>
                <ImportTransactions />
            </AdministrationPage>
        </Guard>
    ),
})
